module.exports = __webpack_public_path__ + "texture-0e818b06cd0c356a9a69b495129c0836.png";